export default __webpack_public_path__ + "0d3d87167de0ad62060e97e80bfb526c.png";